import React, {useEffect, useState} from 'react';
import 'leaflet';
import 'leaflet-draw';
import 'leaflet-timedimension'
import 'leaflet-fullscreen'
import styled from 'styled-components';
import shp from 'shpjs'

import 'leaflet-timedimension/dist/leaflet.timedimension.control.min.css'

import {RasterService} from '../utils/RasterService';
import Attribution from 'components/map/attribution';
import ReactDOM from 'react-dom';

const MapElm = styled.div`
  height: calc(100vh - 109px);
  flex: 1 100%;
  margin-bottom: 25px;
`;
const MapContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

const L = window.L;



L.TimeDimension.Layer.CDrift = L.TimeDimension.Layer.GeoJson.extend({
  _getFeatureTimes: function(feature) {
    const frameToDays = frame => {
      switch(frame) {
        case 0: return 0
        case 1: return 0.5
        case 2: return 1
        case 4: return 2
        case 6: return 3
        case 10: return 5
        case 14: return 7
        case 24: return 10
        case 30: return 15
        case 44: return 22
      }
      throw Error(`Frame ${frame} is not in lookup`)
    }
    if (feature.properties.hasOwnProperty('frame')) {
      return [1616198400000 + (frameToDays(feature.properties.frame) * 60 * 60 * 24 * 1000)]
    }
    return [];
  },

  // Do not modify features. Just return the feature if it intersects
  // the time interval
  _getFeatureBetweenDates: function(feature, minTime, maxTime) {
    const featureStringTimes = this._getFeatureTimes(feature);
    if (featureStringTimes.length === 0) {
      return feature;
    }
    const featureTimes = [];
    for (let i = 0, l = featureStringTimes.length; i < l; i++) {
      let time = featureStringTimes[i]
      if (typeof time == 'string' || time instanceof String) {
        time = Date.parse(time.trim());
      }
      featureTimes.push(time);
    }


    if (featureTimes[0] > maxTime || featureTimes[featureStringTimes.length - 1] < minTime) {
      return null;
    }

    return feature;
  },
});

L.timeDimension.layer.cDrift = function(layer, options) {
  return new L.TimeDimension.Layer.CDrift(layer, options);
};

L.TimeDimension.Layer.TifLayer = L.TimeDimension.Layer.extend({});

L.timeDimension.layer.tifLayer = function(layer, options) {
  return new L.TimeDimension.Layer.TifLayer(layer, options);
};

L.TimeDimension.Layer.TifLayer.Portus = L.TimeDimension.Layer.extend({

  initialize: function(layer, options) {
    console.log('init called')
    L.TimeDimension.Layer.TifLayer.prototype.initialize.call(this, layer, options);
    this._layers = {};
    this._defaultTime = 0;
    this._availableTimes = [];
    this._timeCacheBackward = this.options.cacheBackward || this.options.cache || 0;
    this._timeCacheForward = this.options.cacheForward || this.options.cache || 0;

  },

  eachLayer: function(method, context) {
    for (var prop in this._layers) {
      if (this._layers.hasOwnProperty(prop)) {
        method.call(context, this._layers[prop]);
      }
    }
    return L.TimeDimension.Layer.TifLayer.prototype.eachLayer.call(this, method, context);
  },

  // _onNewTimeLoading: (async function(ev) {
  //   console.log("From new time loading...", new Date(ev.time), new Date(this._currentTime))
  //   var layer = await this._getLayerForTime(ev.time);
  //   if (!this._map.hasLayer(layer)) {
  //     this._map.addLayer(layer);
  //   }
  // }),

  isReady: (async function(time) {
    var layer = await this._getLayerForTime(time);
    var currentZoom = this._map.getZoom();
    if (layer.options.minZoom && currentZoom < layer.options.minZoom){
      return true;
    }
    if (layer.options.maxZoom && currentZoom > layer.options.maxZoom){
      return true;
    }
    return true;
    //return layer.isLoaded();
  }),

  _update: (async function() {
    if (!this._map)
      return;
    const time = this._timeDimension.getCurrentTime();

    // It will get the layer for this time (create or get)
    // Then, the layer will be loaded if necessary, adding it to the map (and show it after loading).
    // If it already on the map (but probably hidden), it will be shown
    const layer = await this._getLayerForTime(time);

    if (this._currentLayer == null) {
      this._currentLayer = layer;
    }
    if (!this._map.hasLayer(layer)) {
      this._map.addLayer(layer);
    } else {
      this._showLayer(layer, time);
    }
  }),

  setOpacity: function(opacity) {
    L.TimeDimension.Layer.TifLayer.prototype.setOpacity.apply(this, arguments);
    // apply to all preloaded caches
    this._currentLayer.setOpacity(opacity);
  },

  setZIndex: function(zIndex){
    L.TimeDimension.Layer.TifLayer.prototype.setZIndex.apply(this, arguments);
    // apply to all preloaded caches
    for (var prop in this._layers) {
      if (this._layers.hasOwnProperty(prop) && this._layers[prop].setZIndex) {
        this._layers[prop].setZIndex(zIndex);
      }
    }
  },

  _unvalidateCache: function() {
    var time = this._timeDimension.getCurrentTime();
    for (var prop in this._layers) {
      if (time !== prop && this._layers.hasOwnProperty(prop)) {
        //this._layers[prop].setLoaded(false); // mark it as unloaded
        this._layers[prop].redraw();
      }
    }
  },

  _evictCachedTimes: function(keepforward, keepbackward) {
    // Cache management
    var times = this._getLoadedTimes();
    var strTime = String(this._currentTime);
    var index = times.indexOf(strTime);
    var remove = [];
    let objectsToRemove
    // remove times before current time
    if (keepbackward > -1) {
      objectsToRemove = index - keepbackward;
      if (objectsToRemove > 0) {
        remove = times.splice(0, objectsToRemove);
        this._removeLayers(remove);
      }
    }
    if (keepforward > -1) {
      index = times.indexOf(strTime);
      objectsToRemove = times.length - index - keepforward - 1;
      if (objectsToRemove > 0) {
        remove = times.splice(index + keepforward + 1, objectsToRemove);
        this._removeLayers(remove);
      }
    }
  },

  _showLayer: function(layer, time) {
    if (this._currentLayer && this._currentLayer !== layer) {
      //this._currentLayer.hide();
      layer.setOpacity(0)
    }
    //layer.show();
    layer.setOpacity(1)
    if (this._currentLayer && this._currentLayer === layer) {
      return;
    }
    this._currentLayer = layer;
    this._currentTime = time;

    this._evictCachedTimes(this._timeCacheForward, this._timeCacheBackward);
  },

  _getLayerForTime: (async function(time) {
    if (time == 0 || time == this._defaultTime || time == null) {
      return this._baseLayer;
    }
    if (this._layers.hasOwnProperty(time)) {
      return this._layers[time];
    }
    var nearestTime = this._getNearestTime(time);
    if (this._layers.hasOwnProperty(nearestTime)) {
      return this._layers[nearestTime];
    }
    const newLayer = await this._createLayerForTime(nearestTime);

    this._layers[time] = newLayer;
    this.fire('timeload', {
      time: time
    });

    console.log(newLayer)

    newLayer.on('load', (function(layer, time) {
      console.log("new layer loaded")
      //layer.setLoaded(true);
      // this time entry should exists inside _layers
      // but it might be deleted by cache management
      if (!this._layers[time]) {
        this._layers[time] = layer;
      }
      if (this._timeDimension && time === this._timeDimension.getCurrentTime() && !this._timeDimension.isLoading()) {
        this._showLayer(layer, time);
      }
      // console.log('Loaded layer ' + layer.wmsParams.layers + ' with time: ' + new Date(time).toISOString());

    }).bind(this, newLayer, time));

    // Hack to hide the layer when added to the map.
    // It will be shown when timeload event is fired from the map (after all layers are loaded)
    // newLayer.onAdd = (function(map) {
    //   Object.getPrototypeOf(this).onAdd.call(this, map);
    //   this.hide();
    // }).bind(newLayer);
    return newLayer;
  }),

  _createLayerForTime: (async function(time){
    console.log(new Date(time))
    var options = this._baseLayer.options;
    var url = this._baseLayer.getURL();

    console.log("We're in create Layer for time")

    var startDate = new Date(time);
    startDate.setUTCHours(0, 0, 0, 0);
    var startDateFormatted = startDate.toISOString().substring(0,10).replace(/-/g, '');
    url = url.replace('{d}', startDateFormatted);

    console.log(this._baseLayer)
    return await RasterService.createRaster(url, this._baseLayer.options.pixelValuesToColorFn,  this._baseLayer.options);
  }),

  _getLoadedTimes: function() {
    var result = [];
    for (var prop in this._layers) {
      if (this._layers.hasOwnProperty(prop)) {
        result.push(prop);
      }
    }
    return result.sort(function(a, b) {
      return a - b;
    });
  },

  _removeLayers: function(times) {
    for (var i = 0, l = times.length; i < l; i++) {
      if (this._map)
        this._map.removeLayer(this._layers[times[i]]);
      delete this._layers[times[i]];
    }
  },

  setMinimumForwardCache: function(value) {
    if (value > this._timeCacheForward) {
      this._timeCacheForward = value;
    }
  },

  _getNearestTime: function(time) {
    if (this._layers.hasOwnProperty(time)) {
      return time;
    }
    if (this._availableTimes.length == 0) {
      return time;
    }
    var index = 0;
    var len = this._availableTimes.length;
    for (; index < len; index++) {
      if (time < this._availableTimes[index]) {
        break;
      }
    }
    // We've found the first index greater than the time. Get the previous
    if (index > 0) {
      index--;
    }
    if (time != this._availableTimes[index]) {
      console.log('Search layer time: ' + new Date(time).toISOString());
      console.log('Return layer time: ' + new Date(this._availableTimes[index]).toISOString());
    }
    return this._availableTimes[index];
  },

});

L.timeDimension.layer.tifLayer.portus = function(layer, options) {
  return new L.TimeDimension.Layer.TifLayer.Portus(layer, options);
};

export default props => {
  const {
    timeDimensionShapefileConfig,
    timeDimensionRasterConfig,
    children,
  } = props;

  const [Map, setMap] = useState(null);

  const [timeDimensionShapeFileLayer, setTimeDimensionShapeFileLayer] = useState(null);
  const [timeDimensionRasterLayer, setTimeDimensionRasterLayer] = useState(null);

  const [attributionString, setAttributionString] = useState("");


  const initTimeDimensionRaster = (async function(config, setState) {
    if (!config.url) return;

    const portusLayer = L.tileLayer(config.url, {
      tms: true,
      maxZoom: config.maxZoom,
      pixelValuesToColorFn: config.pixelValuesToColorFn,
    });
    const startDate = new Date();
    startDate.setUTCHours(0, 1, 0, 0);
    startDate.setFullYear(2020, 4, 1);

    const portusTimeLayer = L.timeDimension.layer.tifLayer.portus(portusLayer, {

    });

    L.timeDimension({
      timeInterval: startDate.toISOString() + "/P4M",
      period: "P1M"
    }).addTo(Map);

    console.log("Should have time info now")
    portusTimeLayer.setZIndex(config.zIndex);
    L.control.layers({'the Layer': portusTimeLayer}).addTo(Map);


    /*timeDimensionOptions: {

      } */

    portusTimeLayer.addTo(Map);
    setState(portusTimeLayer)
  });

 

  const initTimeDimensionShapeFile = (async (config, setState) => {
    // if (!config.url) return;
    // const shapeFileAsGeoJson = await shp(config.url);
    // const shpFileConfig = buildShapeFileConfig(config, props)
    // const layer = L.geoJSON(shapeFileAsGeoJson, shpFileConfig);

    // const timeLayer = L.timeDimension.layer.cDrift(layer, {
    //   updateTimeDimension: true,
    //   updateTimeDimensionMode: 'replace',
    //   addlastPoint: false,
    //   duration: 'PT1H',
    // });
    // setState(timeLayer)
    // window.timeLayer = timeLayer
    // Map.addLayer(timeLayer);
  })


  const initMap = () => {

    const sw = L.latLng(1.1450, 95.48);
    const ne = L.latLng(7.1450, 108.48);
    const bounds = L.latLngBounds(ne, sw);
    const map = L.map('map', {
      fullscreenControl: true,
      timeDimension: true,
      timeDimensionControl: false,
      timeDimensionControlOptions: {
        period: 'T12H',
        position: 'bottomleft',
        autoPlay: false,
        speedSlider: false,
        playerOptions: {
          transitionTime: 1500,
          loop: false,
        }
      },
    }).fitBounds(bounds);
    map.attributionControl.setPrefix('');
    map.attributionControl.addAttribution("<span id='attribution-placeholder'/>");
    setMap(map);
  };


  // useEffect(() => {
  //   if (!Map) return;
  //   removeLayer(timeDimensionShapeFileLayer);
  //   initTimeDimensionShapeFile(timeDimensionShapefileConfig || {}, setTimeDimensionShapeFileLayer)
  // }, [timeDimensionShapefileConfig])

  // useEffect(() => {
  //   if (!Map) return;
  //   removeLayer(timeDimensionRasterLayer)
  //   initTimeDimensionRaster(timeDimensionRasterConfig || {}, setTimeDimensionRasterLayer);
  // }, [timeDimensionRasterConfig])



  useEffect(initMap, []);

  useEffect(() => {
    let attributionPlaceholder = document.getElementById('attribution-placeholder');
    if (!attributionPlaceholder) return;

    ReactDOM.render(
      (<Attribution />), attributionPlaceholder
    );
  }, [])

  const renderChildren = () => {
    if (!children) return; 

    return React.Children.map(children, c => {
      if (c === null) return;
      return React.cloneElement(c, {
        Map: Map

      });
    })
  }

  return (
    <MapContainer>
      <MapElm id="map">
        {renderChildren()}
      </MapElm>
    </MapContainer>);
}